
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[link]",
      function () {
        return require("private-next-pages/blog/[link].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[link]"])
      });
    }
  